import ApiService from '@/common/api/api.service'

let apiBasePath = 'Avaliacao'
const Avaliacoes = {
    // FUNÇÕES CRUD:
    async criar(form) {
        let { data } = await ApiService.post(`${apiBasePath}`, form)
        return data
    },
    async criarComNota(form) {
        if (form.id) {
            let { data } = await ApiService.put(`${apiBasePath}`, {
                ...form
            })
            return data
        } else {
            let { data } = await ApiService.post(`${apiBasePath}/com-nota`, {
                ...form
            })
            return data
        }
    },
    async editar(form) {
        let { data } = await ApiService.put(`${apiBasePath}`, form)
        return data
    },
    async excluir(avaliacaoId) {
        let { data } = await ApiService.delete(`${apiBasePath}/${avaliacaoId}`)
        return data
    },
    // FUNÇÕES FILTRO:
    async obterPorFiltro(filtro, campoOrdenado, ordem) {
        let { data } = await ApiService.get(`Avaliacao/obter-por-filtro`,
            {
                params: {
                    SegmentacaoId: filtro.segmentacaoId,
                    TurmaId: filtro.turmaId,
                    DisciplinaId: filtro.disciplinaId,
                    TamanhoDaPagina: filtro.tamanhoDaPagina,
                    NumeroDaPagina: filtro.numeroDaPagina,
                    CampoOrdenado: campoOrdenado,
                    OrdenacaoAscendente: ordem
                },
            }
        )
        return data
    }
}

export default Avaliacoes